var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tanchuang-frame"},[_c('div',{staticClass:"tanchuang-frame__body"},[_vm._t("default",null,{"backgroundStyle":_vm.backgroundStyle,"backgroundSrc":_vm.backgroundImage})],2),(_vm.title)?_c('div',{staticClass:"tanchuang-frame__title",attrs:{"data-title":_vm.title}},[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }